import { RightOutlined } from "@ant-design/icons";
import { Card, Col, Row, Typography } from "antd";
import React from "react";

const Accessories = ({ product }) => {
  return (
    <div style={{ margin: "24px 0" }}>
      <Typography.Title
        level={3}
        className="accessories-title"
        style={{ marginBottom: "16px", textAlign: "center" }}
      >
        Optional Accessories
      </Typography.Title>
      <Row gutter={[24, 24]}>
        {product?.product_accessory &&
          product?.product_accessory.map((accessory, index) => (
            <Col key={index} xs={24} sm={24} md={12} lg={12} xl={12}>
              <Card style={{ marginBottom: "16px" }}>
                <div style={{ display: "flex", alignItems: "center" }}>
                  <div
                    style={{
                      marginRight: "12px",
                      display: "flex",
                      alignItems: "center",
                    }}
                  >
                    <RightOutlined
                      style={{
                        color: "#1890ff",
                        fontSize: "14px",
                      }}
                    />
                    <RightOutlined
                      style={{
                        color: "#87CEEB",
                        fontSize: "14px",
                        marginLeft: "-9px",
                      }}
                    />
                  </div>
                  <div>
                    <Typography.Text
                      strong
                      className="accessory-heading"
                      style={{ display: "block" }}
                    >
                      {accessory.heading}
                    </Typography.Text>
                    <Typography.Paragraph
                      className="accessory-text"
                      style={{ marginBottom: 0 }}
                    >
                      {accessory.accessory}
                    </Typography.Paragraph>
                  </div>
                </div>
              </Card>
            </Col>
          ))}
      </Row>
    </div>
  );
};

export default Accessories;
